import "../../index8.css";
import { jsx as o, jsxs as u } from "react/jsx-runtime";
import { useContext as d, useRef as f, useEffect as p, useCallback as C } from "react";
import { _ } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import A from "../Alert/index.js";
import b from "../Portal/index.js";
import h from "../../contexts/alert.js";
import { DURATION_DEFAULT_ALERT_DISMISS as D } from "../../utils/constants.js";
const T = "_alert-container_1s23q_1", g = "_alert_1s23q_1", s = {
  alertContainer: T,
  alert: g
};
function S(i) {
  const {
    className: m,
    children: a
  } = i, {
    alerts: n,
    removeAlert: r
  } = d(h), t = f({});
  p(
    () => {
      n.filter((e) => !e.nonDismissable).forEach((e) => {
        t.current[e.name] || (t.current[e.name] = window.setTimeout(
          () => {
            r(e.name), delete t.current[e.name];
          },
          e.duration ?? D
        ));
      });
    },
    [n, r]
  );
  const l = C(
    (e) => {
      const c = t.current[e];
      window.clearTimeout(c), r(e), delete t.current[e];
    },
    [r]
  );
  return n.length === 0 ? null : /* @__PURE__ */ o(b, { children: /* @__PURE__ */ u("div", { className: _(s.alertContainer, m), children: [
    n.map((e) => /* @__PURE__ */ o(
      A,
      {
        name: e.name,
        className: s.alert,
        nonDismissable: e.nonDismissable,
        type: e.variant,
        onCloseButtonClick: l,
        debugMessage: e.debugMessage,
        title: e.title,
        description: e.description
      },
      e.name
    )),
    a
  ] }) });
}
export {
  S as default
};
